<script>

import {axios, swal} from '../../mixins';
import MapBoxGl from '../../../../nova-components/Geometry/resources/js/components/MapBoxGl.vue';
import {Carousel, Icon, Navigation, Pagination, Slide} from 'vue3-carousel';
import portfolioCustomerChart from "./portfolioCustomerChart.vue";
import portfolioAreaChart from "./portfolioAreaChart.vue";

export default {

  name: 'Portfolio',

  props: {
    mapboxToken: {
      type: String,
      required: false,
    },
  },

  components: {MapBoxGl,
    Carousel, Icon, Navigation, Pagination, Slide,
    portfolioCustomerChart,
    portfolioAreaChart,
  },

  mixins: [axios, swal],

  data() {
    return {
      filter: {
        year: null,
        status: null,
        area: null,
      },
      // Loading message display
      loading: true,
      texts: {},
      tooltips: {},
      customers: {},
      areas: {},
      areaList: {},
      statuses: {},
      years: {},
      metrics: {
        acres: null,
        contractValue: null,
        contractCount: null,
        acresUnderContract: null,
        acresVerified: null,
        units: [
          'lbs',
          'lbs',
          'Mg'
        ],
      },
      breakpoints: {
        1: {
          itemsToShow: 1,
          snapAlign: 'start',
        },
        640: {
          itemsToShow: 2,
          snapAlign: 'start',
        },
        768: {
          itemsToShow: 3,
          snapAlign: 'start',
        },
      },
    };
  },

  created() {
    this.getData()
  },

  methods: {
    getData() {
      this.loading = true;
      let route = '/dashboard/portfolio/?' + this.urlParams(this.filter);
      this.get(route).then((response) => {
        console.log(response.data)
        if (response.data.metrics) {
          this.metrics.acres = response.data.metrics.acres;
          this.metrics.contractValue = response.data.metrics.contractValue;
          this.metrics.contractCount = response.data.metrics.contractCount;
          this.metrics.acresUnderContract = response.data.metrics.acresUnderContract;
          this.metrics.acresVerified = response.data.metrics.acresVerified;
          this.metrics.units = response.data.metrics.units;
        }

        if (response.data.filter) {
          this.filter.year = response.data.filter.year;
          this.filter.area = response.data.filter.area;
          this.filter.status = response.data.filter.status;
        }

        this.customers = response.data.customers;
        this.areas = response.data.areas;
        this.areaList = response.data.areaList;
        this.contracts = response.data.contracts;
        this.texts = response.data.texts;
        this.years = response.data.years;
        this.statuses = response.data.statuses;
        for (let key in this.texts) {
          this.tooltips[key] = false;
        }

        this.loading = false;
      }).catch((err) => {
      })
    },
    urlParams(myData) {
      let out = [];
      for (let key in myData) {
        if (myData.hasOwnProperty(key)) {
          if (myData[key] !== null) {
            out.push(key + '=' + encodeURIComponent(myData[key]));
          }
        }
      }
      return out.join('&');
    },
    numberFormat(value) {
      const numberFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
      return numberFormat.format(value);
    },
  },
};

</script>

<template>
  <div>
    <div v-show="this.loading" class="text-center text-white text-2xl font-bold bg-grey-dark p-4">Loading...</div>
    <div class="w-full text-white mb-4 bg-grey-dark rounded-tr rounded-b p-6" v-show="!this.loading">
      <!--  FILTER SELECTS  -->
      <div class="w-full flex flex-col mb-4">
        <div class="flex gap-2 my-auto w-full">
          <div>
            <label hidden for="year">Year</label>
            <select name="year"
                    id="year"
                    v-model="filter.year"
                    @change="getData()"
                    class="md:col-start-4 bg-grey italic text-white border-b border-grey-light w-full py-05 px-3 py-2 rounded-md leading-tight focus:outline-none focus:ring">
              <option :value="null">Year</option>
              <option v-for="year in years" :value="year">{{ year }}</option>
            </select>
          </div>
          <div>
            <label hidden for="year">Status</label>
            <select name="year"
                    id="year"
                    v-model="filter.status"
                    @change="getData()"
                    class="md:col-start-4 bg-grey italic text-white border-b border-grey-light w-full py-05 px-3 py-2 rounded-md leading-tight focus:outline-none focus:ring">
              <option :value="null">Status</option>
              <option v-for="(status, key) in this.statuses" :value="key">{{ status }}</option>
            </select>
          </div>
          <div>
            <label hidden for="year">Area</label>
            <select name="year"
                    id="year"
                    v-model="filter.area"
                    @change="getData()"
                    class="md:col-start-4 bg-grey italic text-white border-b border-grey-light w-full py-05 px-3 py-2 rounded-md leading-tight focus:outline-none focus:ring">
              <option :value="null">Area</option>
              <option v-for="area in this.areaList" :value="area.id">{{ area.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <!--  METRICS / CHARTS  -->
      <div class="grid grid-cols-3 gap-2 order-2 md:order-1 mb-2 text-2xl">

        <!-- TOTAL PAYMENT -->
        <div class="flex flex-col bg-grey rounded-lg">
          <div class="bg-grey-light rounded-t-lg px-2 py-1 font-semibold flex justify-between items-center">
              Total Acres
          </div>
          <div class="flex h-full">
            <div class="text-3xl m-auto p-2">
              {{ numberFormat(this.metrics.acres) }}
            </div>
          </div>
        </div>

        <!-- AVERAGE PAYMENT -->
        <div class="flex flex-col bg-grey rounded-lg">
          <div class="bg-grey-light rounded-t-lg px-2 py-1 font-semibold flex justify-between items-center">
            Avg Payment
          </div>
          <div class="flex h-full">
            <div class="text-3xl m-auto p-2 text-center">
              ${{ (this.metrics.acres !== 0) ? numberFormat(this.metrics.contractValue / this.metrics.acres) : '0' }} /ac
            </div>
          </div>
        </div>

        <!-- CONTRACT VALUE -->
        <div class="flex flex-col bg-grey rounded-lg">
          <div class="bg-grey-light rounded-t-lg px-2 py-1 font-semibold flex justify-between items-center">
            Acres under contract <span class="text-lg float-right">({{ this.numberFormat((this.metrics.acresUnderContract / this.metrics.acres) * 100) }}%)</span>
          </div>
          <div class="flex h-full">
            <div class="text-3xl m-auto p-2">
              {{ numberFormat(this.metrics.acresUnderContract) }}
            </div>
          </div>
        </div>

        <!-- CONTRACT PER ACRE VALUE -->
        <div class="flex flex-col bg-grey rounded-lg">
          <div class="bg-grey-light rounded-t-lg px-2 py-1 font-semibold flex justify-between items-center">
            Contract count
          </div>
          <div class="flex h-full">
            <div class="text-3xl m-auto p-2">
              {{ this.metrics.contractCount }}
            </div>
          </div>
        </div>

        <div class="flex flex-col bg-grey rounded-lg">
          <div class="bg-grey-light rounded-t-lg px-2 py-1 font-semibold flex justify-between items-center">
            Acres verified <span class="text-lg float-right">({{ this.numberFormat((this.metrics.acresVerified / this.metrics.acres) * 100) }}%)</span>
          </div>
          <div class="flex h-full">
            <div class="text-3xl m-auto p-2">
              {{ numberFormat(this.metrics.acresVerified) }}
            </div>
          </div>
        </div>

        <div class="flex flex-col bg-grey rounded-lg">
          <div class="bg-grey-light rounded-t-lg px-2 py-1 font-semibold flex justify-between items-center">
            Avg Acres per contract
          </div>
          <div class="flex h-full">
            <div class="text-3xl m-auto p-2 text-center">
              {{ (this.metrics.contractCount !== 0) ? numberFormat(this.metrics.acres / this.metrics.contractCount) : 'No contracts found' }}
            </div>
          </div>
        </div>

</div>

      <div class="grid grid-cols-2 gap-2">
        <!-- CUSTOMER LIST -->
        <div class="w-full text-white bg-grey rounded-lg mb-4 overflow-y-scroll h-screen">
          <div class="bg-grey-light rounded-t-lg px-2 py-1 font-semibold sticky top-0 text-2xl">
            Customers
          </div>
          <div class="p-4">
            <div v-for="(customer, index) in customers" :key="index" class="my-2 p-2 bg-grey-darker rounded-lg overflow-hidden">
              <h1 class="text-center text-2xl font-semibold py-2">{{ customer.name }}</h1>
              <portfolio-customer-chart :prop-chart-data="customer.chartData">
              </portfolio-customer-chart>
            </div>
          </div>
        </div>

        <!-- AREA LIST  -->
        <div class="w-full text-white bg-grey mb-4 rounded-lg overflow-y-scroll h-screen">
          <div class="bg-grey-light rounded-t-lg px-2 py-1 font-semibold sticky top-0 text-2xl">
            Areas
          </div>
          <div class="p-4">
            <div v-for="(area, index) in areas" :key="index" class="my-2 p-2 bg-grey-darker rounded-lg h-64">
              <h1 class="text-center text-2xl font-semibold py-2">{{ area.name }}</h1>
              <div class="grid grid-cols-2 gap-2">
                  <portfolio-area-chart :prop-chart-data="area.chartData">
                  </portfolio-area-chart>
                <div class="grid grid-cols-2 gap-1">
                  <div class="bg-grey rounded-lg">
                    <div class="bg-grey-lighter w-full rounded-t-lg p-2 font-semibold">
                      Contract count
                    </div>
                    <div class="text-center p-2">
                      {{ area.contractCount }}
                    </div>
                  </div>
                  <div class="bg-grey rounded-lg">
                    <div class="bg-grey-lighter w-full rounded-t-lg p-2 font-semibold">
                      Avg Payment
                    </div>
                    <div class="text-center p-2">
                      ${{ numberFormat(area.averagePayment) }} /ac
                    </div>
                  </div>
                  <div class="bg-grey rounded-lg">
                    <div class="bg-grey-lighter w-full rounded-t-lg p-2 font-semibold">
                      Total Acres
                    </div>
                    <div class="text-center p-2">
                      {{ numberFormat(area.acres) }}
                    </div>
                  </div>
                  <div class="bg-grey rounded-lg">
                    <div class="bg-grey-lighter w-full rounded-t-lg p-2 font-semibold">
                      Acres Verified
                    </div>
                    <div class="text-center p-2">
                      {{ numberFormat(area.acresVerified) }}
                    </div>
                  </div>
                </div>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
